module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('product.reduced.label'),
      "columns": 6
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.product.reduced),
      expression: "options.product.reduced"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options.product, "reduced", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")])]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Caso essa opção seja definida como \"sim\" o arquivo de csv irá retornar apenas os seguintes campos:"), _c('br'), _vm._v("\n        - Sku\n        "), _c('br'), _vm._v("- Ean\n        "), _c('br'), _vm._v("- Preço de\n        "), _c('br'), _vm._v("- Preço por\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9c3398","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/batch/exportProductCsv/Options.vue
// module id = 3077
// module chunks = 0